import { handleActions } from 'redux-actions'
import { resetForgotPasswordState, startResetPassword, startResetPasswordFail } from './ForgotPasswordActions'

export class ForgotPasswordState {
  submitting: boolean = false
}

export const forgotPasswordReducer = handleActions<ForgotPasswordState, any>(
  {
    [String(startResetPassword)]: (state) => ({ ...state, submitting: true }),
    [String(startResetPasswordFail)]: (state) => ({ ...state, submitting: false }),
    [String(resetForgotPasswordState)]: () => new ForgotPasswordState(),
  },
  new ForgotPasswordState(),
)
